import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
const StepOne = () =>
  import(/*webpackChunkName: "Steps" */ "./views/StepOne.vue");
const StepTwo = () =>
  import(/*webpackChunkName: "Steps" */ "./views/StepTwo.vue");
const StepThree = () =>
  import(/*webpackChunkName: "Steps" */ "./views/StepThree.vue");
const StepFour = () =>
  import(/*webpackChunkName: "Steps" */ "./views/StepFour.vue");
const StepFive = () =>
  import(/*webpackChunkName: "Steps" */ "./views/StepFive.vue");

// import StepOne from "./views/StepOne.vue";
// import StepTwo from "./views/StepTwo.vue";
// import StepThree from "./views/StepThree.vue";
// import StepFour from "./views/StepFour.vue";
import RequestView from "./views/RequestView.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { page: 0 },
    },

    {
      path: "/StepOne",
      name: "stepone",
      component: StepOne,
      meta: { page: 1 },
      beforeEnter: (to, from, next) => {
        // console.log("step1", from.path);
        if (
          from.path == "/" ||
          from.path == "/RequestView" ||
          from.path == "/StepFive" ||
          from.path == "/StepTwo"
        ) {
          next();
        } else next("/");
      },
    },
    {
      path: "/StepTwo",
      name: "steptwo",
      component: StepTwo,
      meta: { page: 2 },
      beforeEnter: (to, from, next) => {
        // console.log("step2", from.path);
        if (
          from.path == "/StepOne" ||
          from.path == "/RequestView" ||
          from.path == "/StepThree"
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/StepThree",
      name: "stepthree",
      component: StepThree,
      meta: { page: 3 },
      beforeEnter: (to, from, next) => {
        // console.log("step3", from.path);
        if (from.path == "/StepTwo" || from.path == "/StepFour") {
          next();
        } else next("/");
      },
    },
    {
      path: "/StepFour",
      name: "stepfour",
      component: StepFour,

      meta: { page: 4 },
      beforeEnter: (to, from, next) => {
        if (from.path == "/StepThree" || from.path == "/StepFive") {
          next();
        } else next("/");
      },
    },
    {
      path: "/StepFive",
      name: "stepfive",
      component: StepFive,

      meta: { page: 5 },
      beforeEnter: (to, from, next) => {
        if (from.path == "/StepFour" || from.path == "/Submit") {
          next();
        } else next("/");
      },
    },

    {
      path: "/RequestView",
      name: "requestview",
      meta: { page: 7 } /*"./views/RequestView.vue"), */,
      /* component: () =>
        import(/* webpackChunkName: "requestview" */

      component: RequestView,
      props: true,
    },
    {
      path: "/Submit",
      name: "submit",
      meta: { page: 5 },
      component: () =>
        import(/* webpackChunkName: "submit" */ "./views/Submit.vue"),
      beforeEnter: (to, from, next) => {
        if (from.path == "/RequestView" || from.path == "/StepFive") {
          next();
        } else next("/");
      },
    },
    {
      path: "/Thanks",
      name: "thanks",
      meta: { page: 6 },
      component: () =>
        import(/* webpackChunkName: "submit" */ "./views/Thanks.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
